import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import { withI18n } from 'react-i18next';
import { Alert } from 'reactstrap';
import CONFIGS from 'configs';
import { withFormik, Form, Field } from 'formik';
import * as Yup from 'yup';

class SignIn extends Component {
  render() {
    const {
      t,
      authState,
      onStateChange,
      errors,
      touched,
      isSubmitting,
    } = this.props;

    const { logo, APP_TITLE } = CONFIGS;
    if (authState !== 'signIn') return null;
    return (
      <div className="container h-100 mt-5 pt-5">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="form-signin">
            <div className="text-center">
              <img src={logo} alt="" width="92" height="92" />
              <h1 className="h3 mb-3 font-weight-bold">
                {t('welcome')}
                &nbsp;
                {APP_TITLE}
              </h1>
            </div>
            <Form>
              {errors.main && <Alert color="danger">{t(errors.main)}</Alert>}
              <div className="mb-3">
                <label className="font-weight-bold" htmlFor="inputEmail">
                  {t('email')}
                </label>
                <Field
                  type="email"
                  name="email"
                  placeholder={t('email')}
                  className="form-control"
                />
                {touched.email && errors.email && (
                  <div className="invalid-feedback d-block">
                    {t(errors.email)}
                  </div>
                )}
              </div>
              <div>
                <label className="font-weight-bold" htmlFor="inputPassword">
                  {t('password')}
                </label>
                <Field
                  type="password"
                  name="password"
                  placeholder={t('password')}
                  className="form-control"
                />
                {touched.password && errors.password && (
                  <div className="invalid-feedback d-block">
                    {t(errors.password)}
                  </div>
                )}
              </div>
              <button
                className="btn btn-primary btn-block mt-4"
                type="submit"
                disabled={isSubmitting}
              >
                {t('login')}
              </button>
            </Form>
            <div className="text-center">
              <button
                className="btn bluecolor mt-2 mb-2"
                type="button"
                onClick={() => onStateChange('forgotPassword')}
              >
                <u>{t('forgot_your_password')}</u>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const FormikSignIn = withFormik({
  mapPropsToValues({ email, password }) {
    return {
      email: email || '',
      password: password || '',
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string().email('email_not_valid').required('email_required'),
    password: Yup.string().required('password_required'),
  }),
  async handleSubmit(values, { setErrors, setSubmitting, props }) {
    const { email, password } = values;
    const adjustedEmail = email.trim().toLowerCase();
    try {
      const user = await Auth.signIn(adjustedEmail, password);
      switch (user.challengeName) {
        // Here, additional challenges may be added when required.
        case 'SMS_MFA':
          props.onStateChange('confirmSignIn', user);
          break;
        case 'MFA_SETUP':
          Auth.setupTOTP(user);
          break;
        case 'NEW_PASSWORD_REQUIRED':
          props.onStateChange('requireNewPassword', user);
          break;
        default:
          props.onStateChange('signedIn', user);
          break;
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      if (
        err.name === 'NotAuthorizedException' ||
        err.name === 'UserNotFoundException'
      )
        setErrors({ main: 'username_password_not_found' });
    }
    setSubmitting(false);
  },
})(SignIn);

SignIn.defaultProps = {
  touched: {
    email: '',
    password: '',
  },
  errors: {
    email: '',
    password: '',
  },
};

SignIn.propTypes = {
  t: PropTypes.func.isRequired,
  authState: PropTypes.string.isRequired,
  onStateChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  touched: PropTypes.shape({
    email: PropTypes.bool,
    password: PropTypes.bool,
  }),
  errors: PropTypes.shape({
    main: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
  }),
};

export default withI18n()(FormikSignIn);
